import { EMPTY_ARR } from '@constants';

import useResourceList from './useResourceList';
import useQuery from './useQuery';

import api from '..';

export const useFiltersList = (queryVariables = {}, queryConfig = {}) => {
  const queryResult = useResourceList({ name: 'filters', api: api.filters }, queryVariables, queryConfig);

  return {
    filters: queryResult.resolvedData,
    latestFilters: queryResult.latestData,
    ...queryResult,
  };
};

export const useFiltersByIds = (ids, { passErrors, ...queryConfig } = {}) => {
  const queryResult = useQuery(['filters', { ids, passErrors }], api.filters.getByIds, {
    ...queryConfig,
    enabled: ids?.length > 0,
  });

  return {
    filters: queryResult.data || EMPTY_ARR,
    ...queryResult,
  };
};
